import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { SharedService } from '../../../layouts/shared-service';
//Services
import { AuthenticationService } from '../../../services/security/authentication.service';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
import { GroupsService } from 'src/app/services/groups.service';
import { UserRole } from 'src/app/enums/user-role';
import { PermissionsService } from 'src/app/services/security/permissions.service';
import { NewDesignUrlService } from 'src/app/services/new-design-url.service';

@Component({
    selector: 'app-login-modal',
    styleUrls: ['./login-modal.component.scss'],
    templateUrl: './login-modal.component.html',
})
export class LoginModalComponent {
    @Output() dialogAction = new EventEmitter<{ action: string; data?: any }>();

    loginForm: UntypedFormGroup;
    error: '';
    public groupsFbosData: any;
    // URL of the new (Blazor) app — drives the "Try the new design" link. Empty hides it.
    public newDesignUrl = '';

    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private authenticationService: AuthenticationService,
        private sharedService: SharedService,
        private groupsService: GroupsService,
        private permissions: PermissionsService,
        private newDesignUrlService: NewDesignUrlService
    ) {
        this.loginForm = this.formBuilder.group({
            password: new UntypedFormControl(''),
            remember: new UntypedFormControl(false),
            username: new UntypedFormControl(''),
        });
        this.newDesignUrl = this.newDesignUrlService.forLoginScreen();
        authenticationService.clearSessionData();
    }
    onCancelClick(): void {
        this.dialogAction.emit({ action: 'close', data: true });
    }

    public onSubmit() {
        //this must be moved to authentication service
        if (this.loginForm.valid) {
            this.authenticationService
                .login(
                    this.loginForm.value.username,
                    this.loginForm.value.password,
                    this.loginForm.value.remember
                )
                .subscribe(
                    (data: any) => {
                        this.newDesignUrlService.rememberLoginOptIn(data.featureFlags);
                        this.completeClassicLogin(data);
                    },
                    (error: any) => {
                        this.error = error.error.message;
                    }
                );
        }
    }
    // Logs the user in with the credentials entered here, then hands off to the new
    // (Blazor) design. Authentication sets the shared httpOnly auth cookie, which the
    // new app restores its session from — so the user signs in once and lands in the
    // new design already authenticated, instead of logging in twice. A user who isn't
    // opted in stays on the classic app.
    public onTryNewDesign() {
        if (!this.loginForm.valid) {
            return;
        }
        this.authenticationService
            .login(
                this.loginForm.value.username,
                this.loginForm.value.password,
                this.loginForm.value.remember
            )
            .subscribe(
                (data: any) => {
                    this.newDesignUrlService.rememberLoginOptIn(data.featureFlags);
                    const url = data.role === UserRole.Conductor
                        ? this.newDesignUrlService.resolve()
                        : this.newDesignUrlService.forSession(data.featureFlags);
                    if (url) {
                        this.dialogAction.emit({ action: 'close' });
                        this.redirectToNewDesign(url);
                        return;
                    }
                    this.completeClassicLogin(data);
                },
                (error: any) => {
                    this.error = error.error.message;
                }
            );
    }
    private completeClassicLogin(data: any) {
        this.authenticationService.postAuth().subscribe(async (urls) => {

            this.permissions.setRoles([data.role]);
            this.permissions.setIsFboSelected(true);

            this.sharedService.supportUrl = urls.supportUrl;
            this.sharedService.memberUrl = urls.memberUrl;

            this.dialogAction.emit({ action: 'close' });

            if (data.role === UserRole.Conductor) {
                this.router.navigate([
                    '/default-layout/groups/',
                ]);
            } else if (data.role === UserRole.GroupAdmin) {
                this.router.navigate(['/default-layout/fbos/']);
            } else {
                this.setFboSessionVariables(data);

                if (data.username == 'aeromap@test.com') {
                   this.router.navigateByUrl('/public-layout/lobby-view?map-type=aero');
                    return;
                } 

                if (data.role === UserRole.CSR)
                    this.router.navigate([
                        '/default-layout/dashboard-csr/',
                    ]);
                else if (data.role == UserRole.AnalysisOnly)
                    this.router.navigate([
                        '/default-layout/analytics/',
                    ]);
                else
                    this.router.navigate([
                        '/default-layout/dashboard-fbo-updated/',
                    ]);
            }
        });
    }

    private redirectToNewDesign(url: string) {
        window.location.href = url;
    }

    private async setFboSessionVariables(fboObj: any) {
        let icao: string = fboObj.icao;
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.accountType,fboObj.fbo?.accountType);
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.fbo,fboObj.fbo.fbo);
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.fboId,fboObj.fboId);
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.icao,icao);
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.isNetworkFbo,(fboObj.group.fbos?.length > 1));
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.accountType,fboObj.fbo?.accountType);
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.groupId,fboObj.groupId);

        var isSingleSourceFbo = await this.groupsService.isGroupFboSingleSource(icao).toPromise();
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.isSingleSourceFbo,isSingleSourceFbo.toString());
    }
    public openRequestDemo() {
        this.dialogAction.emit({ action: 'request-demo' });
    }

    public openForgotPassword() {
        this.dialogAction.emit({ action: 'forgot-password' });
    }
}
